import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { Link } from "react-router-dom";
import Dialog from "material-ui/Dialog";
import handleMutationError from "app/utils/handleMutationError";

let OFFSET = 0;
let LIMIT = 9;

class BankSettlementSummary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      details: null,
      payments: [],
      offset: OFFSET,
      limit: LIMIT,
      log: [],
      other_settlements: [],
      loading: false,
      settlement_dialog_open: false,
      settlement_dialog_title: "",
      settlement_dialog_comment: "",
      settlement_new_status: "",
      payment_dialog_open: false,
      payment_dialog_title: "",
      payment_dialog_comment: "",
      payment_new_status: "",
      selected_rows: [],
    };

    // DATA LOAD
    this.loadAllData = this.loadAllData.bind(this);
    this.loadDetails = this.loadDetails.bind(this);
    this.loadPayments = this.loadPayments.bind(this);
    this.loadLogs = this.loadLogs.bind(this);
    this.loadOther = this.loadOther.bind(this);

    // PAGINATION
    this.paginateNext = this.paginateNext.bind(this);
    this.paginatePrev = this.paginatePrev.bind(this);

    this.settlementStatusDialog = this.settlementStatusDialog.bind(this);
    this.submitStatus = this.submitStatus.bind(this);

    this.paymentStatusDialog = this.paymentStatusDialog.bind(this);
    this.submitPaymentStatus = this.submitPaymentStatus.bind(this);

    this.selectRow = this.selectRow.bind(this);
  }

  componentDidMount() {
    this.loadAllData();
  }
  componentWillReceiveProps(nextProps: any) {
    if (this.props.match.params.id !== nextProps.match.params.id) {
      this.loadAllData();
    }
  }

  loadAllData() {
    this.setState({
      details: null,
      payments: [],
      offset: OFFSET,
      limit: LIMIT,
      log: [],
      other_settlements: [],
      loading: false,
      settlement_dialog_open: false,
      settlement_dialog_title: "",
      settlement_dialog_comment: "",
      settlement_new_status: "",
      payment_dialog_open: false,
      payment_dialog_title: "",
      payment_dialog_comment: "",
      payment_new_status: "",
      selected_rows: [],
    });
    this.loadDetails();
    this.loadPayments(0);
    this.loadLogs();
    this.loadOther();
  }
  loadDetails() {
    this.setState({ details: null });
    this.props.bank_settlement_details.fetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) => {
        let data = fetchMoreResult.bank_settlements[0];
        this.setState({ details: data });
      },
    });
  }
  loadPayments(offset: any) {
    this.setState({ payments: [], offset: offset });

    this.props.bank_settlement_payments.fetchMore({
      variables: {
        offset: offset,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        let data = fetchMoreResult.bank_settlements[0].payments;
        this.setState({ payments: [...data] });
      },
    });
  }
  loadLogs() {
    this.setState({ log: [] });
    this.props.bank_settlement_logs.fetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) => {
        let data = fetchMoreResult.bank_settlements[0].activity_logs;
        this.setState({ log: [...data] });
      },
    });
  }
  loadOther() {
    this.setState({ other_settlements: [] });
    this.props.other_settlements.fetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) => {
        let data =
          fetchMoreResult.bank_settlements[0].merchant.bank_settlements;
        this.setState({ other_settlements: [...data] });
      },
    });
  }

  paginateNext() {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) + parseInt(this.state.limit, 10);
    this.loadPayments(TMP_OFFSET);
  }
  paginatePrev() {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) - parseInt(this.state.limit, 10);
    this.loadPayments(TMP_OFFSET);
  }

  settlementStatusDialog(status: any) {
    let newStatus = status === "Release" ? "release" : "withhold";
    this.setState({
      settlement_dialog_open: true,
      settlement_dialog_title: `${status} settlement`,
      settlement_dialog_comment: "",
      settlement_new_status: newStatus,
    });
  }
  submitStatus(status: any) {
    if (this.state.settlement_dialog_comment !== "") {
      if (status === "release") {
        this.setState({ settlement_dialog_open: false });
        this.props
          .release_settlement({
            variables: {
              id: this.props.match.params.id,
              comment: this.state.settlement_dialog_comment,
            },
          })
          .then(() => {
            this.loadAllData();
          })
          .catch(handleMutationError);
      } else {
        this.setState({ settlement_dialog_open: false });
        this.props
          .withhold_settlement({
            variables: {
              id: this.props.match.params.id,
              comment: this.state.settlement_dialog_comment,
            },
          })
          .then(() => {
            this.loadAllData();
          })
          .catch(handleMutationError);
      }
    }
  }

  paymentStatusDialog(status: any) {
    let newStatus = status === "Release" ? "release" : "withhold";
    this.setState({
      payment_dialog_open: true,
      payment_dialog_title: `${status} Payment(s)`,
      payment_dialog_comment: "",
      payment_new_status: newStatus,
    });
  }
  submitPaymentStatus(status: any) {
    if (this.state.payment_dialog_comment !== "") {
      if (status === "release") {
        this.setState({ payment_dialog_open: false });
        this.props
          .release_payments_for_settlement({
            variables: {
              id: this.props.match.params.id,
              comment: this.state.payment_dialog_comment,
              payment_references: this.state.selected_rows,
            },
          })
          .then(() => {
            this.loadAllData();
          })
          .catch(handleMutationError);
      } else {
        this.setState({ payment_dialog_open: false });
        this.props
          .withhold_payments_from_settlement({
            variables: {
              id: this.props.match.params.id,
              comment: this.state.payment_dialog_comment,
              payment_references: this.state.selected_rows,
            },
          })
          .then(() => {
            this.loadAllData();
          })
          .catch(handleMutationError);
      }
    }
  }

  selectRow(event: any, reference: any) {
    let updatedSelectedRows = [...this.state.selected_rows];

    if (event.target.checked) {
      if (!updatedSelectedRows.includes(reference)) {
        updatedSelectedRows.push(reference);
      }
    } else {
      updatedSelectedRows = updatedSelectedRows.filter(
        (item) => item !== reference
      );
    }

    this.setState({ selected_rows: updatedSelectedRows });
  }

  render() {
    let details = this.state.details ? this.state.details : null;
    let payments = this.state.payments.length > 0 ? this.state.payments : [];
    let logs = this.state.log.length > 0 ? this.state.log : [];
    let otherSettlements =
      this.state.other_settlements.length > 0
        ? this.state.other_settlements
        : [];

    // Format Date
    const formatDate = (date) => {
      let DateObj = new Date(date);
      let formatFullDate = `${DateObj.getFullYear()}-${(
        "0" + (parseInt(DateObj.getMonth().toString(), 10) + 1).toString()
      ).slice(-2)}-${("0" + DateObj.getDate()).slice(-2)} ${(
        "0" + DateObj.getHours()
      ).slice(-2)}:${("0" + DateObj.getMinutes()).slice(-2)}:${(
        "0" + DateObj.getSeconds()
      ).slice(-2)}`;
      return <span>{formatFullDate}</span>;
    };

    //  SECURE 3D
    const formatSecure3D = (status3D) => {
      if (status3D) {
        return <i className="fa fa-lock fa-lg" style={{ color: "green" }} />;
      } else {
        return <i className="fa fa-minus fa-lg" style={{ color: "red" }} />;
      }
    };

    //  HAS_REFUND?
    const formatHasRefund = (truth) => {
      if (truth) {
        return <i className="fa fa-check fa-lg" style={{ color: "green" }} />;
      } else {
        return <i className="fa fa-minus fa-lg" style={{ color: "red" }} />;
      }
    };

    //  STATUS FORMATING
    const formatStatusColour = (status) => {
      if (status === "completed") {
        return "#ebffeb";
      } else if (status === "pending") {
        return "white";
      } else if (status === "error") {
        return "#ffebeb";
      } else {
        return "white";
      }
    };

    const paymentStatusButton = () => {
      if (this.state.selected_rows.length > 0) {
        if (details && details.status === "withheld") {
          return (
            <span>
              <button
                className="button"
                style={{ zoom: "0.8" }}
                onClick={() => this.paymentStatusDialog("Release")}
              >
                Release
              </button>{" "}
              {this.state.selected_rows.length} payment(s)
            </span>
          );
        } else {
          return (
            <span>
              <button
                className="button"
                style={{ zoom: "0.8" }}
                onClick={() => this.paymentStatusDialog("Withhold")}
              >
                Withhold
              </button>{" "}
              {this.state.selected_rows.length} payment(s)
            </span>
          );
        }
      } else {
        return null;
      }
    };

    const showDetails = () => {
      let checkVal = (val) => {
        if (val && val !== "" && val !== " ") {
          return <span>{val}</span>;
        } else {
          return <i>No value.</i>;
        }
      };

      let settlementStatusButton = (status) => {
        if (
          (details &&
            details.settlement_batch &&
            details.settlement_batch.status === "pending") ||
          (details && !details.settlement_batch)
        ) {
          if (status === "withheld") {
            return (
              <div
                style={{ width: "150px", display: "inline-block" }}
                className="button"
                onClick={() => this.settlementStatusDialog("Release")}
              >
                Release
              </div>
            );
          } else {
            return (
              <div
                style={{ width: "150px", display: "inline-block" }}
                className="button"
                onClick={() => this.settlementStatusDialog("Withhold")}
              >
                Withhold
              </div>
            );
          }
        } else {
          return null;
        }
      };

      let checkBatch = (batch) => {
        if (batch) {
          return <span>{batch.status}</span>;
        } else {
          return <i>No value.</i>;
        }
      };

      let bool = (val) => {
        if (val) {
          return "Yes";
        } else {
          return "No";
        }
      };

      if (details) {
        return (
          <tbody>
            <tr style={{ fontSize: "14px" }}>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                <b style={{ fontWeight: 400 }}>Batch status:</b>
              </td>
              <td style={{ padding: "5px" }}>
                {checkBatch(details.settlement_batch)}
              </td>
              <td colSpan={2} style={{ textAlign: "right" }}>
                {settlementStatusButton(details.status)}
              </td>
            </tr>
            <tr style={{ fontSize: "14px" }}>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                <b style={{ fontWeight: 400 }}>Date:</b>
              </td>
              <td style={{ padding: "5px" }}>{checkVal(details.created_at)}</td>
              <td style={{ padding: "5px", paddingLeft: "20px" }}>
                <b style={{ fontWeight: 400 }}>Settlement status:</b>
              </td>
              <td style={{ padding: "5px" }}>{checkVal(details.status)}</td>
            </tr>
            <tr>
              <td colSpan={4}>
                <h3
                  style={{
                    borderBottom: "1px solid rgb(204, 204, 204)",
                    paddingBottom: "10px",
                    fontWeight: 400,
                    marginBottom: "12px",
                    marginTop: "12px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span style={{ flex: 1 }}>Banking details</span>
                </h3>
              </td>
            </tr>
            <tr style={{ fontSize: "14px" }}>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                <b style={{ fontWeight: 400 }}>Bank name:</b>
              </td>
              <td style={{ padding: "5px" }}>{checkVal(details.bank_name)}</td>
              <td style={{ padding: "5px", paddingLeft: "20px" }}>
                <b style={{ fontWeight: 400 }}>Bank branch code:</b>
              </td>
              <td style={{ padding: "5px" }}>
                {checkVal(details.bank_branch_code)}
              </td>
            </tr>
            <tr style={{ fontSize: "14px" }}>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                <b style={{ fontWeight: 400 }}>Bank account number:</b>
              </td>
              <td style={{ padding: "5px" }}>
                {checkVal(details.bank_account_number)}
              </td>
              <td style={{ padding: "5px", paddingLeft: "20px" }}>
                <b style={{ fontWeight: 400 }}>Bank recipient name:</b>
              </td>
              <td style={{ padding: "5px" }}>
                {checkVal(details.bank_recipient_name)}{" "}
              </td>
            </tr>
            <tr style={{ fontSize: "14px" }}>
              <td style={{ padding: "5px", paddingLeft: 0 }}>
                <b style={{ fontWeight: 400 }}>Statement reference:</b>
              </td>
              <td style={{ padding: "5px" }}>
                {checkVal(details.statement_reference)}
              </td>
              <td style={{ padding: "5px", paddingLeft: "20px" }}>
                <b style={{ fontWeight: 400 }}>Manual verification:</b>
              </td>
              <td style={{ padding: "5px" }}>
                {checkVal(bool(details.manual_verification))}
              </td>
            </tr>
          </tbody>
        );
      } else {
        return null;
      }
    };

    const showPayments = () => {
      if (details) {
        const checboxEl = (reference) => {
          if (
            (details &&
              details.settlement_batch &&
              details.settlement_batch.status === "pending") ||
            (details && !details.settlement_batch)
          ) {
            return (
              <td style={{ textAlign: "center" }}>
                <input
                  type="checkbox"
                  onClick={(e) => this.selectRow(e, reference)}
                />
              </td>
            );
          } else {
            return null;
          }
        };
        return payments.map((val, key) => {
          return (
            <tr
              key={key}
              style={{ backgroundColor: formatStatusColour(val.status) }}
            >
              {checboxEl(val.reference)}
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/payments/${val.reference}/summary`}
                >
                  {" "}
                  {formatDate(val.created_at)}{" "}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={val.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/users/${val.device.user.external_reference}/payments`}
                >
                  {" "}
                  {val.device.user.email}{" "}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={val.device.user.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td> {val.payment_strategy} </td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/devices/${val.device.external_reference}/summary`}
                >
                  {" "}
                  {val.device.phone_number}{" "}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={val.device.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td style={{ textAlign: "right" }}>
                {" "}
                R
                {(parseInt(val.payable_amount_post_refunds, 10) / 100).toFixed(
                  2
                )}
              </td>
              <td> {formatSecure3D(val.secure3d_requested)}</td>
              <td>{formatHasRefund(val.has_refund)}</td>
            </tr>
          );
        });
      } else {
        return (
          <tr>
            <td colSpan={5}>No Payments</td>
          </tr>
        );
      }
    };

    const showLogs = () => {
      if (details && logs.length > 0) {
        return logs.map((val, key) => {
          return (
            <li
              key={key}
              style={{
                padding: "5px 0",
                fontSize: "10pt",
              }}
            >
              <i>{val.username}</i> - {val.comment}
            </li>
          );
        });
      } else {
        return (
          <li
            style={{
              padding: "5px 0",
              listStyle: "none",
            }}
          >
            No activity on settlement.
          </li>
        );
      }
    };

    const showOther = () => {
      if (details && otherSettlements.length > 0) {
        return otherSettlements.map((val, key) => {
          return (
            <li
              key={key}
              style={{
                padding: "5px 0",
              }}
            >
              <Link
                className="blueLink"
                to={`/snapscan/settlements/bank_settlements/${val.id}/summary`}
              >
                {val.id}
              </Link>{" "}
              - {val.status}
            </li>
          );
        });
      } else {
        return (
          <li
            style={{
              padding: "5px 0",
              listStyle: "none",
            }}
          >
            None found.
          </li>
        );
      }
    };

    const title = () => {
      if (details) {
        return `Bank Settlement ${this.props.match.params.id} - ${details.merchant.name}`;
      } else {
        return null;
      }
    };

    const checkboxElHeader = () => {
      if (
        (details &&
          details.settlement_batch &&
          details.settlement_batch.status === "pending") ||
        (details && !details.settlement_batch)
      ) {
        return <th style={{ textAlign: "center" }} />;
      } else {
        return null;
      }
    };

    return (
      <section className="padded">
        <h3
          style={{
            borderBottom: "1px solid rgb(204, 204, 204)",
            fontWeight: 400,
            marginTop: 0,
          }}
        >
          {title()}
        </h3>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            height: "calc(100% - 35px)",
          }}
        >
          <aside
            style={{
              maxWidth: "220px",
              padding: "5px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: "220px",
              }}
            >
              <h4
                style={{
                  margin: 0,
                  border: "1px solid #999",
                  borderBottom: 0,
                  padding: "5px",
                  fontSize: "13px",
                  fontWeight: 400,
                }}
              >
                Merchant Bank Settlements
              </h4>
              <ul
                style={{
                  border: "1px solid #999",
                  margin: "10px 0",
                  marginTop: "0",
                  padding: "5px 0",
                  paddingLeft: "25px",
                  flex: 1,
                }}
              >
                {showOther()}
              </ul>
            </span>
            <span
              style={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <h4
                style={{
                  margin: 0,
                  border: "1px solid #999",
                  borderBottom: 0,
                  padding: "5px",
                  fontSize: "13px",
                  fontWeight: 400,
                }}
              >
                Activity Log
              </h4>
              <ul
                style={{
                  border: "1px solid #999",
                  margin: "10px 0",
                  marginTop: "0",
                  padding: "5px 0",
                  paddingLeft: "25px",
                  flex: 1,
                  overflow: "auto",
                }}
              >
                {showLogs()}
              </ul>
            </span>
          </aside>
          <aside
            style={{
              width: "calc(100% - 220px)",
              padding: "5px",
              overflow: "auto",
            }}
          >
            <table
              style={{
                width: "100%",
              }}
              cellSpacing={0}
              cellPadding={0}
            >
              {showDetails()}
            </table>
            <div>
              <h3
                style={{
                  borderBottom: "1px solid rgb(204, 204, 204)",
                  fontWeight: 400,
                  display: "flex",
                  alignItems: "center",
                  paddingBottom: "10px",
                  marginTop: "10px",
                }}
              >
                <span style={{ flex: 1 }}>Payments</span>
                {paymentStatusButton()}
              </h3>
              <div
                id="setHeight"
                style={{
                  height: "calc(50% - 120px)",
                  overflow: "auto",
                }}
              >
                <table
                  style={{
                    width: "100%",
                  }}
                  className={`BOTable`}
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <thead>
                    <tr>
                      {checkboxElHeader()}
                      <th>Date</th>
                      <th>User</th>
                      <th>Payment strategy</th>
                      <th>Device</th>
                      <th style={{ textAlign: "right" }}>Payable amount</th>
                      <th>Secure 3D</th>
                      <th>Has Refund</th>
                    </tr>
                  </thead>
                  <tbody>{showPayments()}</tbody>
                </table>
                <button
                  className={
                    this.state.offset === 0 || this.state.loading
                      ? "hidden"
                      : ""
                  }
                  style={{ margin: "5px", padding: "4px" }}
                  onClick={this.paginatePrev}
                >
                  <i className="fa fa-chevron-left" />
                </button>
                <button
                  style={{ margin: "5px", padding: "4px" }}
                  className={
                    payments.length < LIMIT || this.state.loading
                      ? "hidden"
                      : ""
                  }
                  onClick={this.paginateNext}
                >
                  <i className="fa fa-chevron-right" />
                </button>
              </div>
            </div>
          </aside>
        </div>

        <Dialog
          title={this.state.settlement_dialog_title}
          modal={false}
          open={this.state.settlement_dialog_open}
          onRequestClose={() =>
            this.setState({ settlement_dialog_open: false })
          }
          actions={[
            <input
              type="button"
              className={`button ${
                this.state.settlement_dialog_comment !== "" ? "" : "hidden"
              }`}
              value="Save"
              onClick={() =>
                this.submitStatus(this.state.settlement_new_status)
              }
            />,
            <input
              type="button"
              className="button"
              value="Close"
              onClick={() => this.setState({ settlement_dialog_open: false })}
            />,
          ]}
          autoScrollBodyContent={true}
        >
          <br />
          <label>Comment: </label>
          <input
            style={{
              padding: "5px",
              border: "1px solid #999",
              borderRadius: "4px",
              outline: "none",
            }}
            type="text"
            value={this.state.settlement_dialog_comment}
            onChange={(e) =>
              this.setState({ settlement_dialog_comment: e.target.value })
            }
          />
        </Dialog>
        <Dialog
          title={this.state.payment_dialog_title}
          modal={false}
          open={this.state.payment_dialog_open}
          onRequestClose={() => this.setState({ payment_dialog_open: false })}
          actions={[
            <input
              type="button"
              className={`button ${
                this.state.payment_dialog_comment !== "" ? "" : "hidden"
              }`}
              value="Save"
              onClick={() =>
                this.submitPaymentStatus(this.state.payment_new_status)
              }
            />,
            <input
              type="button"
              className="button"
              value="Close"
              onClick={() => this.setState({ payment_dialog_open: false })}
            />,
          ]}
          autoScrollBodyContent={true}
        >
          <br />
          <label>Comment: </label>
          <input
            style={{
              padding: "5px",
              border: "1px solid #999",
              borderRadius: "4px",
              outline: "none",
            }}
            type="text"
            value={this.state.payment_dialog_comment}
            onChange={(e) =>
              this.setState({ payment_dialog_comment: e.target.value })
            }
          />
        </Dialog>
      </section>
    );
  }
}

// QUERIES
const BankSettlementSummaryQr = graphql(
  gql`
    query BankSettlementsofBatch($id: ID) {
      bank_settlements(id: $id) {
        status
        created_at
        bank_name
        bank_branch_code
        bank_account_number
        bank_recipient_name
        statement_reference
        manual_verification
        settlement_batch {
          id
          status
        }
        merchant {
          id
          name
          snapmin_url
        }
      }
    }
  `,
  {
    name: "bank_settlement_details",
    options(props: any) {
      return {
        variables: {
          id: props.match.params.id,
        },
      };
    },
  }
);
const BankSettlementPayments = graphql(
  gql`
    query BankSettlementPayments($offset: Int, $limit: Int, $id: ID) {
      bank_settlements(id: $id) {
        payments(offset: $offset, limit: $limit) {
          payment_token
          reference
          created_at
          payable_amount_post_refunds
          has_refund
          status
          payment_strategy
          snapmin_url
          secure3d_requested
          device {
            phone_number
            snapmin_url
            external_reference
            user {
              email
              external_reference
              snapmin_url
            }
          }
        }
      }
    }
  `,
  {
    name: "bank_settlement_payments",
    options(props: any) {
      return {
        variables: {
          id: props.match.params.id,
          offset: OFFSET,
          limit: LIMIT,
        },
      };
    },
  }
);
const BankSettlementLogQr = graphql(
  gql`
    query BankSettlementLog($id: ID) {
      bank_settlements(id: $id) {
        activity_logs {
          created_at
          comment
          username
          event
          snapmin_url
        }
      }
    }
  `,
  {
    name: "bank_settlement_logs",
    options(props: any) {
      return {
        variables: {
          id: props.match.params.id,
        },
      };
    },
  }
);
const OtherSettlementsQR = graphql(
  gql`
    query OtherSettlements($id: ID) {
      bank_settlements(id: $id) {
        merchant {
          bank_settlements(limit: 5) {
            id
            status
          }
        }
      }
    }
  `,
  {
    name: "other_settlements",
    options(props: any) {
      return {
        variables: {
          id: props.match.params.id,
        },
      };
    },
  }
);

// MUTATIONS
const releasePayments = graphql(
  gql`
    mutation releasePayments(
      $id: ID!
      $comment: String!
      $payment_references: [String]!
    ) {
      release_payments_for_settlement(
        id: $id
        comment: $comment
        payment_references: $payment_references
      ) {
        created_at
      }
    }
  `,
  {
    name: "release_payments_for_settlement",
  }
);
const withholdPayments = graphql(
  gql`
    mutation withholdPayments(
      $id: ID!
      $comment: String!
      $payment_references: [String]!
    ) {
      withhold_payments_from_settlement(
        id: $id
        comment: $comment
        payment_references: $payment_references
      ) {
        created_at
      }
    }
  `,
  {
    name: "withhold_payments_from_settlement",
  }
);
const releaseSettlement = graphql(
  gql`
    mutation releaseSettlement($id: ID!, $comment: String!) {
      release_settlement(id: $id, comment: $comment) {
        created_at
        id
      }
    }
  `,
  {
    name: "release_settlement",
  }
);
const withholdSettlement = graphql(
  gql`
    mutation withholdSettlement($id: ID!, $comment: String!) {
      withhold_settlement(id: $id, comment: $comment) {
        created_at
      }
    }
  `,
  {
    name: "withhold_settlement",
  }
);

export default BankSettlementSummaryQr(
  BankSettlementPayments(
    BankSettlementLogQr(
      OtherSettlementsQR(
        releasePayments(
          withholdPayments(
            releaseSettlement(withholdSettlement(BankSettlementSummary))
          )
        )
      )
    )
  )
);
